// extracted by mini-css-extract-plugin
module.exports = {"locationSearch":"LocationSearch_locationSearch__mRjN8","suggestionBg":"LocationSearch_suggestionBg__10s7h","searchResult":"LocationSearch_searchResult__2MAhy"};